<template lang="pug">
.create
  v-container(v-if="!selectedTheme")
    div(style="height: 40vh")
      v-skeleton-loader( min-height="100%" type="image" )
  v-container(v-else)
    v-row.overview()
      v-col(cols="12", md="5", xl="4")
        MotionConfigForm
      v-col(cols="12", md="7", xl="8")
        MotionPlayer

  .mt-4.timelineContainer.timeline.d-flex.flex-column.flex-sm-row.justify-start()

        v-container.py-0.d-flex.flex-column.flex-sm-row.justify-start
              
            draggable.d-flex.flex-column.flex-sm-row.justify-start(
              v-model="timelineElements",
              group="videos",
              :move="checkMove",
              handle=".draggable"
            )
              
              timeline-item.dragItem(
                v-for="(element, index) in timelineElements",
                :class="{draggable : !element.fixed}"
                :video="element",
                :index="index",
                :key="index",
                :itemsCount="timelineElements.length"
                :isActive="element.id === selectedElement.id",
                @clicked="previewMe"
                @layerChanged="(overlays) =>setOverlaysForElementAtIndex({index, overlays, replace: true})"
              )


  
            
</template>

<script>
import draggable from "vuedraggable";
import urlFormat from "@/utils/urlFormat";
import { fmtMSS } from "@/utils/format";
import MotionPlayer from "@/components/player/MotionPlayer";
import TimelineItem from "@/components/create/timelineItems/TimelineItem";

import MotionConfigForm from "@/components/create/MotionConfigForm";
import { mapState, mapMutations, mapGetters } from "vuex";

// import { EventBus } from "@/event-bus";

// import { VideoElement } from "@/models";
import { mapFields } from "vuex-map-fields";
// import { debounce } from "debounce";

export default {
  name: "SetClipsStep",
  components: {
    draggable,
    TimelineItem,
    MotionConfigForm,
    MotionPlayer,
  },
  watch: {
    timelineElements: function (newList) {
      if (newList.findIndex((e) => e.id === this.selectedElement.id) > -1)
        return;
      if (newList.length > 0) {
        this.selectedElement = newList[0];
      }
    },
  },
  computed: {
    ...mapFields("create", {
      selectedElement: "selectedElement",
      currentTimePosition: "currentTimePosition",
    }),
    ...mapState({
      currentSettings: (state) => state.settings.settings,
      selectedTheme: (state) => state.create.selectedTheme,
      includeIntro: (state) => state.create.motionSettings.includeIntro,
      includeOutro: (state) => state.create.motionSettings.includeOutro,
      includeLogo: (state) => state.create.motionSettings.includeLogo,
      includeMusic: (state) => state.create.motionSettings.includeMusic,
      includeOverlay: (state) => state.create.motionSettings.includeOverlay,
    }),
    ...mapGetters({
      intro: "create/intro",
      outro: "create/outro",
      defaultVideo: "create/defaultVideo",
    }),

    timelineElements: {
      // getter
      get: function () {
        return this.$store.state.create.timelineElements;
      },
      // setter
      set: function (newValue) {
        return this.$store.commit("create/set_timeline_elements", newValue);
      },
    },
    fixedTimelinePositions() {
      const elementsCount = this.timelineElements.length;
      const fixedPositions = [elementsCount - 1, elementsCount - 2]; // add btn & outro
      if (!this.selectedTheme.excludeIntro) {
        fixedPositions.push(0);
      }
      return fixedPositions;
    },
  },
  methods: {
    ...urlFormat,
    fmtMSS,
    checkMove(e) {
      return !this.fixedTimelinePositions.includes(
        e.draggedContext.futureIndex
      );
    },
    ...mapMutations("create", {
      setOverlaysForElementAtIndex: "set_overlays_for_element_at_index",
    }),
    previewMe(item) {
      this.selectedElement = item;
    },
  },
};
</script>
<style lang="sass" scoped>
@import '@/assets/style/variables'
.draggable
  cursor: grab
.timelineContainer
    min-height: 100px
    max-width: 100% !important
    background-color: white
    padding-top: 10px
    padding-bottom: 10px
    padding-right: 12px
    padding-left: 12px
    overflow-x: auto
    overflow-y: hidden
    margin-bottom: 40px

@media only screen and (min-width: 991px)
  .timelineContainer
    position: sticky !important
    left: 0
    right: 0
    bottom: 64px
.dragItem
  margin: 0 6px
  transition: all 0.4s ease


.overview
  position: relative
</style>
